 <template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('hrDesc.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div  class="desc-content">
            <div class="desc-box">
                <div class="desc-title">{{$t('hrDesc.title0')}}</div>
                <div class="desc-info">{{$t('hrDesc.desc0')}}</div>
                <div class="desc-title">{{$t('hrDesc.title1')}}</div>
                <div class="desc-info">{{$t('hrDesc.desc1')}}</div>
                <div class="desc-title">{{$t('hrDesc.title2')}}</div>
                <div class="desc-info">{{$t('hrDesc.desc2')}}</div>
                <div class="desc-title">{{$t('hrDesc.title3')}}</div>
                <div class="desc-info">{{$t('hrDesc.desc3')}}</div>
                <div class="desc-title">{{$t('hrDesc.title4')}}</div>
                <div class="desc-info">{{$t('hrDesc.desc4')}}</div>
                <div class="desc-title">{{$t('hrDesc.title5')}}</div>
                <div class="desc-info">{{$t('hrDesc.desc5')}}</div>
                <div class="desc-title">{{$t('hrDesc.title6')}}</div>
                <div class="desc-info last-desc">{{$t('hrDesc.desc6')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: '03hrDesc',
        data() {
            return {
                theme: 'light'
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme;
            }
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/status/03hrDesc.vue